























import EditOnClickField from '@/components/util/EditOnClickField.vue';

import { Component, Vue, Prop } from 'vue-property-decorator';
import { WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class JobPriorityEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Priority' })
  private label!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  @Prop({ required: false, type: Boolean, default: true })
  private displayInline!: boolean;

  private priorityMode = 'read';

  private updatedValue: string | number | undefined = undefined;

  private loading!: boolean;

  private ordersApi!: WorkordersApi;

  data() {
    return { updatedValue: this.value, loading: false };
  }

  private async handlePriorityChange(priority: number) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === priority) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeJobPriority({
        workorderId: this.workorderId,
        changeOrderJobPriorityCommand: {
          newJobPriority: priority
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.priorityMode = 'read';
    this.loading = false;
  }
}
